import React from "react";
import { motion } from "framer-motion";

const steps = [
  { n: "01", title: "Assess", body: "Understand communication, resume, confidence and interview readiness." },
  { n: "02", title: "Prepare", body: "Build stronger communication, resume presentation and interview responses." },
  { n: "03", title: "Practice", body: "Group discussions, public speaking, interview questions and mock interviews." },
  { n: "04", title: "Improve", body: "Receive practical feedback and work on weaknesses." },
  { n: "05", title: "Perform", body: "Enter actual hiring opportunities with better preparation and confidence." },
];

export default function Journey() {
  return (
    <section className="py-24 sm:py-32 bg-[#0B132B] text-white relative overflow-hidden">
      <div className="absolute inset-0 grid-bg opacity-25" />
      <div className="relative max-w-7xl mx-auto px-5 sm:px-8">
        <div className="max-w-3xl">
          <div className="text-xs tracking-[0.28em] uppercase text-slate-400">The BHR Method</div>
          <h2 className="mt-3 font-display text-3xl sm:text-5xl leading-tight">From Candidate to <span className="text-metallic">Hire-Ready</span></h2>
        </div>

        <div className="mt-14 relative">
          <div className="hidden lg:block absolute top-10 left-8 right-8 h-px bg-gradient-to-r from-white/5 via-white/25 to-white/5" />
          <div className="grid gap-5 lg:grid-cols-5">
            {steps.map((s, i) => (
              <motion.div key={s.n}
                          initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
                          transition={{ delay: i * 0.12 }}
                          className="relative">
                <div className="glass-dark rounded-2xl p-5 h-full">
                  <div className="flex items-center justify-between">
                    <span className="text-[11px] tracking-widest text-slate-400">STAGE {s.n}</span>
                    <span className="h-6 w-6 rounded-full ring-1 ring-white/20 grid place-items-center text-[10px] text-slate-300">{i + 1}</span>
                  </div>
                  <div className="mt-4 font-display text-xl">{s.title}</div>
                  <p className="mt-2 text-sm text-slate-400 leading-relaxed">{s.body}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
